// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1xxny","title":"Info_title__1UoQa","selects":"Info_selects__1R1IK","requiredAsterisk":"Info_requiredAsterisk__3s3Gr"};